import { request } from "../axios/request";

import {
  FETCH_PRODUCT_PENDING,
  FETCH_PRODUCT_REJECTED,
  FETCH_PRODUCT_FULFILLED,
  ADD_BASKET_PENDING,
  ADD_BASKET_REJECTED,
  ADD_BASKET_FULFILLED,
  CLEAR_PRODUCT_DETAIL,
} from "../constants/productDetail";

import { FETCH_BASKET_FULFILLED } from "../constants/basket";

const $URLS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);
const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

var variants = {};

const pending = () => ({
  type: FETCH_PRODUCT_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_PRODUCT_FULFILLED,
  response: response,
});

const rejected = (error) => ({
  type: FETCH_PRODUCT_REJECTED,
  error: error,
});

const addBasketPending = () => ({
  type: ADD_BASKET_PENDING,
});

const addBasketRejected = (error) => ({
  type: ADD_BASKET_REJECTED,
  error: error,
});

const addBasketFulfilled = (response) => ({
  type: ADD_BASKET_FULFILLED,
  response: response,
});

export const clearProductDetail = () => ({
  type: CLEAR_PRODUCT_DETAIL,
});

export const fetchProduct = (id) => (dispatch) => {
  const params = buildQueryParam();
  dispatch(pending());

  request({
    method: "get",
    url: `${$URLS.PRODUCT_DETAIL}${id}/?format=json${params}`,
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

/**
 * It replaces all instances of the ampersand character with the string "%26" and all instances of the
 * semicolon character with the string "%3B"
 * @param val {String}  - The value to be encoded.
 * @returns the value of the variable val.
 */
function speacialCharacterEncode(val) {
  return val.replace(/&/g, "%26").replace(/;/g, "%3B");
}

const buildQueryParam = () => {
  let query = "";
  const hasBrandValue = ["SAMSUNG", "Samsung-b2b"].includes($A.BRAND);

  Object.keys(variants).forEach((key) => {
    query = hasBrandValue
      ? `${query}&${key}=${speacialCharacterEncode(variants[key].value)}`
      : `${query}&${key}=${variants[key]}`;
  });
  return query;
};

export const setVariant = (searchKey, variant, pk) => {
  variants[searchKey] = variant;
  return fetchProduct(pk);
};

export const resetVariants = () => (dispatch) => {
  variants = {};
};

export const addBasket =
  (quantity, pk, attributes = {}) =>
  (dispatch) => {
    dispatch(addBasketPending());

    request({
      url: $URLS.BASKET,
      method: "POST",
      data: {
        product: pk,
        quantity: quantity,
        attributes,
      },
    })
      .then((response) => {
        dispatch(addBasketFulfilled(response.data));
        localStorage.setItem("localBaskedItem", JSON.stringify(response.data));
        dispatch({
          type: FETCH_BASKET_FULFILLED,
          response: response.data,
        });
      })
      .catch((error) => {
        dispatch(addBasketRejected(error));
      });
  };

export const addCampaignToBasket = (pk, quantity, subItems) => (dispatch) => {
  dispatch(addBasketPending());
  request({
    url: $URLS.BASKET,
    method: "POST",
    data: {
      product: pk,
      quantity: quantity,
      sub_items: subItems,
    },
  })
    .then((response) => {
      dispatch(addBasketFulfilled(response.data));
      dispatch({
        type: FETCH_BASKET_FULFILLED,
        response: response.data,
      });
    })
    .catch((error) => {
      dispatch(addBasketRejected(error));
    });
};

export const addBothCampaignToBasket =
  (quantity, pk, tradableId, answerData, subItems) => (dispatch) => {
    dispatch(addBasketPending());
    const hasBrandValue = ["Samsung-tec", "Samsung-b2b"].includes($A.BRAND);

    const inquiry = {
      items: answerData,
      ...(hasBrandValue
        ? { answers: answerData, tradable_item_id: tradableId }
        : {}),
    };

    request({
      url: $URLS.BASKET,
      method: "POST",
      data: {
        product: pk,
        quantity: quantity,
        sub_items: subItems,
        attributes: {
          inquiry,
        },
      },
    })
      .then((response) => {
        dispatch(addBasketFulfilled(response.data));
        dispatch({
          type: FETCH_BASKET_FULFILLED,
          response: response.data,
        });
      })
      .catch((error) => {
        dispatch(addBasketRejected(error));
      });
  };

export const addChangeCampaignToBasket =
  (quantity, pk, tradableId, answerData) => (dispatch) => {
    dispatch(addBasketPending());
    const items = answerData
      ? answerData.map((item) => {
          item.answers = item.answers
            ? item.answers.filter((answer) => {
                return answer && typeof answer.question === "number";
              })
            : [];
          return item;
        })
      : [];

    request({
      url: $URLS.BASKET,
      method: "POST",
      data: {
        product: pk,
        quantity: quantity,
        attributes: {
          inquiry: {
            items,
            tradable_item_id: tradableId,
          },
        },
      },
    })
      .then((response) => {
        dispatch(addBasketFulfilled(response.data));
        dispatch({
          type: FETCH_BASKET_FULFILLED,
          response: response.data,
        });
      })
      .catch((error) => {
        dispatch(addBasketRejected(error));
      });
  };



// WEBPACK FOOTER //
// ./src/actions/productDetail.js